// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCollapsibleSection-Loading_cls1__A+6W3","cls2":"VeloCollapsibleSection-Loading_cls2__Kh8jD VeloCollapsibleSection-Loading_cls1__A+6W3"};